import { useParams } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { Loading } from 'app/components/Loading';
import { ErrorMessageBox } from 'bf-library';
import { BoardQnaForm } from './BoardQnaForm';


export const BoardQnaModify = ()=>{
    const { id } = useParams();
    
    const { data:qna, isLoading, isError, error } = useQuery({
        queryKey:['board/qna', id],
        queryFn:()=>Api.get(`/api/board/qna/${id}`),
        refetchOnMount:'always',
        refetchOnWindowFocus: false,
        gcTime: Infinity,
        staleTime: Infinity
    });

    if(isLoading)return <Loading />;
    if(isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
    return <BoardQnaForm qna={qna.data} />
}